// extracted by mini-css-extract-plugin
export var content = "zAa57LRxQgVueCUDIeQm";
export var info = "KNqIBlS4zngKs0p7y9oL";
export var link = "ayGo4pmqCKjyo0_B9Rxq";
export var negative = "LkTc8kf9DRa7JoZwFVu5";
export var neutral = "zKxr5V4WWbf9HdfT4lHm";
export var positive = "Ij_rI3nypZX8NOM4Oki9";
export var primary = "Qji0p0z2e8V0g2WR6SJw";
export var root = "fsuFnqYNKC1TBMWDJPZb";
export var secondary = "XiJLkq3uCXst0QK5mCE3";
export var sideItem = "SDAMWLnrsVC4Vt5zmJOT";
export var warning = "us22q8w5mXOAFzv35Ajw";